import React, { useState, useEffect } from 'react';
import CategorySection from '../components/Categories'; // your updated component
import axios from "axios";

import configs from '../config/config';
// ── Preset Definitions ───────────────────────────────────────────────────────
const PRESETS = {
  'modern-glass': {
    label: 'Modern Glass Cards',
    description: 'Elegant glassmorphism with blur, subtle borders and smooth hover effects',
    cardStyles: {
      background: 'bg-white/70 backdrop-blur-xl',
      border: 'border border-white/30',
      shadow: 'shadow-2xl',
      hoverScale: 'hover:scale-105 hover:shadow-3xl',
      padding: 'p-6',
      transition: 'transition-all duration-500 ease-out',
    },
    cardBorderRadius: 'rounded-3xl',
    cardHeight: 340,
    displayMode: 'icon',
    container: {
      padding: 'py-16 md:py-24',
        textColor:'#111827',
        textAlign:'left',

        featuredBg:'bg-white',
    activeBg:'bg-gray-900',
     fontSize: '2em',
         fontFamily: configs.FONT_FAMILY,
    borderRadius:'10px',
    cardBackground:'bg-white',
accentColor:'green',
      background: 'bg-gradient-to-b from-gray-50 to-white',
      margin: 'mx-auto max-w-9xl',
    },
    headerAlignment: 'text-center',
  },

  'floating-circles': {
    label: 'Floating Gradient Circles',
    description: 'Bold circular cards with vibrant gradients and playful hover animations',
    cardStyles: {
      background: 'bg-gradient-to-br',
      border: 'border-none',
      shadow: 'shadow-2xl',
      hoverScale: 'hover:scale-110 hover:rotate-2',
      padding: 'p-10',
      transition: 'all 0.6s cubic-bezier(0.34, 1.56, 0.64, 1)',
    },
    cardBorderRadius: 'rounded-full',
    cardHeight: 380,
    displayMode: 'icon',
    container: {
      padding: 'py-20 md:py-32',
        textColor:'#111827',
        textAlign:'left',
        featuredBg:'bg-white',
    activeBg:'bg-gray-900',
     fontSize: '2em',
         fontFamily: configs.FONT_FAMILY,
    borderRadius:'10px',
    cardBackground:'bg-white',
accentColor:'green',
      background: 'bg-gray-900',
      margin: 'mx-auto max-w-9xl',
    },
    headerAlignment: 'text-center',
  },

  'large-gradient': {
    label: 'Large Gradient Cards',
    description: 'Big, bold gradient cards with generous padding and clean look',
    cardStyles: {
      background: 'bg-gradient-to-br from-white to-gray-50',
      border: 'border border-gray-200',
      shadow: 'shadow-xl',
      hoverScale: 'hover:scale-105',
      padding: 'p-12',
      transition: 'all 0.4s ease',
    },
    cardBorderRadius: 'rounded-2xl',
    cardHeight: 420,
    displayMode: 'image',
    container: {
      padding: 'py-16 md:py-20',
        textColor:'#111827',
        textAlign:'left',
        featuredBg:'bg-white',
    activeBg:'bg-gray-900',
     fontSize: '2em',
         fontFamily: configs.FONT_FAMILY,
    borderRadius:'10px',
    cardBackground:'bg-white',
accentColor:'green',
      background: 'bg-white',
      margin: 'mx-auto max-w-9xl',
    },
    headerAlignment: 'text-center',
  },

  'carousel': {
    label: 'Carousel with Controls',
    description: 'Horizontal scrolling carousel with navigation arrows and dots',
    cardStyles: {
      background: 'bg-white',
      border: 'border border-gray-200',
      shadow: 'shadow-md',
      hoverScale: 'hover:shadow-lg',
      padding: 'p-6',
      transition: 'all 0.3s ease',
    },
    cardBorderRadius: 'rounded-xl',
    cardHeight: 360,
    displayMode: 'image',
    container: {
      padding: 'py-12 md:py-16',
      background: 'bg-gray-50',
        textColor:'#111827',
        textAlign:'left',
        featuredBg:'bg-white',
    activeBg:'bg-gray-900',
     fontSize: '2em',
         fontFamily: configs.FONT_FAMILY,
    borderRadius:'10px',
    cardBackground:'bg-white',
accentColor:'green',
      margin: 'mx-auto max-w-9xl',
    },
    headerAlignment: 'text-center',
  },

  'clean-grid': {
    label: 'Clean Grid (legacy)',
    description: 'Simple, minimal grid layout without heavy shadows or effects',
    cardStyles: {
      background: 'bg-white',
      border: 'border border-gray-200',
      shadow: 'shadow-sm',
      hoverScale: 'hover:shadow-md',
      padding: 'p-4',
      transition: 'all 0.2s ease',
    },
    cardBorderRadius: 'rounded-lg',
    cardHeight: 280,
    displayMode: 'icon',
    container: {
      padding: 'py-12 md:py-16',
      background: 'bg-white',
        textColor:'#111827',
        textAlign:'left',
        featuredBg:'bg-white',
    activeBg:'bg-gray-900',
     fontSize: '2em',
         fontFamily: configs.FONT_FAMILY,
    borderRadius:'10px',
    cardBackground:'bg-white',
accentColor:'green',
      margin: 'mx-auto max-w-9xl',
    },
    headerAlignment: 'text-center',
  },

  'card-grid': {
    label: 'Card Grid (legacy)',
    description: 'Classic card-based grid with moderate shadows',
    cardStyles: {
      background: 'bg-white',
      border: 'border border-gray-200',
      shadow: 'shadow-md hover:shadow-xl',
      hoverScale: 'hover:scale-102',
      padding: 'p-6',
      transition: 'all 0.3s ease',
    },
    cardBorderRadius: 'rounded-xl',
    cardHeight: 320,
    displayMode: 'image',
    container: {
      padding: 'py-12 md:py-16',
      background: 'bg-gray-50',
        textColor:'#111827',
        textAlign:'left',
        featuredBg:'bg-white',
    activeBg:'bg-gray-900',
     fontSize: '2em',
         fontFamily: configs.FONT_FAMILY,
    borderRadius:'10px',
    cardBackground:'bg-white',
accentColor:'green',
      margin: 'mx-auto max-w-9xl',
    },
    headerAlignment: 'text-center',
  },
};

const CategoryAdmin = ({ config: initialConfig = {}, slug = '', onSave, onClose }) => {
  const [preset, setPreset] = useState('modern-glass');
  const [title, setTitle] = useState('Shop by Category');
  const [subtitle, setSubtitle] = useState('Discover what you love');
  const [categories, setCategories] = useState([]);
  const [allCategories, setAllCategories] = useState([]);

  const [displayMode, setDisplayMode] = useState('icon');

  const [grid, setGrid] = useState({ mobileCols: 2, desktopCols: 4 });
  const [imageSize, setImageSize] = useState({ width: 1, height: 1 });
  const [cardHeight, setCardHeight] = useState(320);
  const [cardBorderRadius, setCardBorderRadius] = useState('rounded-3xl');

  const [cardStyles, setCardStyles] = useState({
    background: 'bg-white',
    border: 'border border-gray-100',
    shadow: 'shadow-lg hover:shadow-2xl',
    hoverScale: 'hover:scale-105',
    padding: 'p-8',
    transition: 'transition-all duration-500',
  });

  const [titleStyle, setTitleStyle] = useState({
    color: '#111827',
    fontSize: 'text-4xl md:text-6xl',
    fontWeight: 'font-bold',
    fontFamily: 'font-sans',
  });

  const [subtitleStyle, setSubtitleStyle] = useState({
    color: '#4B5563',
    fontSize: 'text-lg md:text-xl',
    fontWeight: 'font-normal',
    fontFamily: 'font-sans',
  });

  const [headerAlignment, setHeaderAlignment] = useState('text-center');

  const [devMode, setDevMode] = useState(false);
  const [container, setContainer] = useState({
    padding: 'py-12 md:py-16',
    background: 'bg-white',
    margin: 'mx-auto max-w-9xl',
    borderRadius: '',
    boxShadow: '',
  });

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [fullScreenPreview, setFullScreenPreview] = useState(false);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedCategoryIds, setSelectedCategoryIds] = useState([]);

  const token = localStorage.getItem("token");

  // ── Apply preset defaults when preset changes ───────────────────────────────
  useEffect(() => {
    if (preset in PRESETS) {
      const p = PRESETS[preset];

      // Apply preset defaults
      setCardStyles(prev => ({ ...prev, ...p.cardStyles }));
      setCardBorderRadius(p.cardBorderRadius || cardBorderRadius);
      setCardHeight(p.cardHeight || cardHeight);
      setContainer(prev => ({ ...prev, ...p.container }));
      setDisplayMode(p.displayMode || displayMode);
      setHeaderAlignment(p.headerAlignment || headerAlignment);

      // Update all categories to match preset's display mode
      setCategories(prevCats =>
        prevCats.map(cat => ({
          ...cat,
          displayMode: p.displayMode || cat.displayMode,
          iconColor: p.cardStyles?.background?.includes('gradient')
            ? 'from-indigo-500 to-purple-600'
            : cat.iconColor || 'from-blue-500 to-indigo-600',
        }))
      );
    }
  }, [preset]);

  // ── Load from DB ─────────────────────────────────────────────────────────────
  useEffect(() => {
    const loadCategorySettings = async () => {
      if (!token) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        await axios.get(configs.API_URL + "/sanctum/csrf-cookie", { withCredentials: true });

        let response;
        const isDuplicate = slug.includes('-');

        if (isDuplicate) {
          response = await axios.get(
            `${configs.API_URL}/api/pullCustomSettings/${slug}`,
            { headers: { Authorization: `Bearer ${token}` }, withCredentials: true }
          );
        } else {
          response = await axios.get(
            configs.API_URL + '/api/pullCategorySettings',
            { headers: { Authorization: `Bearer ${token}` }, withCredentials: true }
          );
        }

        const dbData = isDuplicate 
          ? (response.data.customSettings || {})
          : (response.data.categorySettings || {});

        setPreset(dbData.preset || 'modern-glass');
        setTitle(dbData.title || title);
        setSubtitle(dbData.subtitle || subtitle);
        setCategories(dbData.categories || []);
        setDisplayMode(dbData.displayMode || displayMode);
        setGrid(dbData.grid || grid);
        setImageSize(dbData.imageSize || imageSize);
        setCardHeight(dbData.cardHeight || cardHeight);
        setCardBorderRadius(dbData.cardBorderRadius || cardBorderRadius);
        setCardStyles(dbData.cardStyles || cardStyles);
        setTitleStyle(dbData.titleStyle || titleStyle);
        setSubtitleStyle(dbData.subtitleStyle || subtitleStyle);
        setHeaderAlignment(dbData.headerAlignment || headerAlignment);
        setDevMode(dbData.devMode || devMode);
        setContainer(dbData.customStyles?.container || container);
      } catch (error) {
        console.error("Failed to load category settings:", error);
      } finally {
        setLoading(false);
      }
    };

    loadCategorySettings();
  }, [token, slug]);

  // ── Fetch all categories for modal ──────────────────────────────────────────
  const fetchAllCategories = async () => {
    try {
      const response = await axios.get(`${configs.API_URL}/api/pullCategories`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setAllCategories(response.data.newCategories || []);
    } catch (err) {
      console.error("Fetch categories error:", err);
    }
  };

  useEffect(() => {
    if (token) fetchAllCategories();
  }, [token]);

  // ── Current config for preview & save ───────────────────────────────────────
  const currentConfig = {
    preset,
    title,
    subtitle: subtitle || null,
    categories,
    displayMode,
    grid,
    imageSize,
    cardHeight,
    cardBorderRadius,
    cardStyles,
    titleStyle,
    subtitleStyle,
    headerAlignment,
    devMode,
    customStyles: { container },
  };

  // ── Save ─────────────────────────────────────────────────────────────────────
  const saveCategorySettings = async () => {
    try {
      setSaving(true);
      await axios.get(configs.API_URL + "/sanctum/csrf-cookie", { withCredentials: true });

      const xsrfToken = document.cookie
        .split('; ')
        .find(row => row.startsWith('XSRF-TOKEN='))
        ?.split('=')[1];

      const payload = { settings: currentConfig };

      const response = await axios.post(
        configs.API_URL + "/api/saveCategorySettings" + (slug ? `/${slug}` : ''),
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
            "X-XSRF-TOKEN": decodeURIComponent(xsrfToken || ''),
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true,
        }
      );

      if (response.data.status === 1) {
        alert("Category section saved successfully! 🎉");
        if (onSave) onSave(currentConfig);
      } else {
        alert("Save failed.");
      }
    } catch (error) {
      console.error("Save error:", error);
      alert("Failed to save changes.");
    } finally {
      setSaving(false);
    }
  };

  // ── Category helpers ──────────────────────────────────────────────────────
  const addCategory = () => {
    setCategories([...categories, {
      id: Date.now(),
      name: "New Category",
      items: "0",
      icon: "ShoppingBag",
      iconColor: "from-blue-500 to-indigo-600",
      image: "",
      displayMode: 'icon',
      titleStyle: { ...titleStyle },
      subtitleStyle: { ...subtitleStyle },
    }]);
  };

  const updateCategory = (id, field, value) => {
    setCategories(categories.map(c => c.id === id ? { ...c, [field]: value } : c));
  };

  const updateCategoryStyle = (id, element, property, value) => {
    setCategories(categories.map(c =>
      c.id === id ? {
        ...c,
        [element]: { ...c[element], [property]: value }
      } : c
    ));
  };

  const removeCategory = (id) => {
    setCategories(categories.filter(c => c.id !== id));
  };

  const moveCategory = (id, direction) => {
    const index = categories.findIndex(c => c.id === id);
    if ((direction === -1 && index === 0) || (direction === 1 && index === categories.length - 1)) return;
    const newCats = [...categories];
    [newCats[index], newCats[index + direction]] = [newCats[index + direction], newCats[index]];
    setCategories(newCats);
  };

  const handleImageUpload = (id, e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = () => {
      updateCategory(id, 'image', reader.result);
    };
    reader.readAsDataURL(file);
  };

  // Modal helpers
  const openAddCategoryModal = () => {
    setSearchQuery('');
    setSelectedCategoryIds([]);
    setIsModalOpen(true);
  };

  const toggleCategorySelection = (categoryId) => {
    setSelectedCategoryIds(prev =>
      prev.includes(categoryId)
        ? prev.filter(id => id !== categoryId)
        : [...prev, categoryId]
    );
  };

  const confirmAddCategories = () => {
    const newCategories = allCategories
      .filter(c => selectedCategoryIds.includes(c.id))
      .map(c => ({
        id: c.id,
        name: c.name,
        items: `${c.product_count || 0}`,
        image: c.image_url || '',
        icon: "ShoppingBag",
        iconColor: "from-blue-500 to-indigo-600",
        displayMode: 'icon',
        titleStyle: { ...titleStyle },
        subtitleStyle: { ...subtitleStyle },
      }));

    const existingIds = new Set(categories.map(c => c.id));
    const filteredNew = newCategories.filter(c => !existingIds.has(c.id));

    setCategories(prev => [...prev, ...filteredNew]);
    setIsModalOpen(false);
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center">
        <p className="text-xl text-gray-600">Loading category settings...</p>
      </div>
    );
  }

  const currentPreset = PRESETS[preset] || {};

  return (
    <div className="min-h-screen bg-gray-100 flex">
      {/* Preview Area – Sticky/Fixed */}
      <div className="flex-1 sticky top-0 self-start h-screen overflow-hidden">
        <div className="h-full flex flex-col">
          <div className="bg-white border-b px-6 py-4 flex justify-between items-center shadow-sm z-10">
            <h1 className="text-2xl font-bold text-gray-900">Category Section Editor</h1>
            <button
              onClick={() => setFullScreenPreview(true)}
              className="bg-blue-600 text-white px-6 py-3 rounded-lg font-medium hover:bg-blue-700 shadow transform hover:scale-105 transition"
            >
              Full Screen Preview
            </button>
          </div>
          <div className="flex-1 overflow-auto bg-gradient-to-b from-gray-50 to-gray-100 p-8">
            <CategorySection config={currentConfig} />
          </div>
        </div>
      </div>

      {/* Settings Drawer – Scrollable */}
      <div className="w-96 bg-white border-l overflow-y-auto shadow-2xl relative h-screen">
        <div className="p-6 space-y-6">
          <h2 className="text-xl font-semibold text-gray-900">Category Settings</h2>

          {/* Current Preset Info */}
          <div className="bg-blue-50 border border-blue-200 rounded-xl p-5">
            <h3 className="font-semibold text-blue-900">
              Current Preset: {currentPreset.label || 'Custom'}
            </h3>
            <p className="text-sm text-blue-700 mt-1">
              {currentPreset.description || 'Custom configuration'}
            </p>
          </div>

          {/* Layout Preset */}
          <details open>
            <summary className="font-medium cursor-pointer text-lg">Layout Preset</summary>
            <div className="mt-3 grid gap-3">
              {Object.entries(PRESETS).map(([value, p]) => (
                <button
                  key={value}
                  onClick={() => setPreset(value)}
                  className={`p-4 border rounded-lg text-left transform hover:scale-105 transition ${
                    preset === value ? 'border-blue-500 bg-blue-50' : 'border-gray-200'
                  }`}
                >
                  <span className="font-medium">{p.label}</span>
                </button>
              ))}
            </div>
          </details>

          {/* Display Mode */}
          <details open>
            <summary className="font-medium cursor-pointer text-lg">Display Mode</summary>
            <div className="mt-3 space-y-3">
              <select
                value={displayMode}
                onChange={e => {
                  setDisplayMode(e.target.value);
                  setCategories(categories.map(c => ({ ...c, displayMode: e.target.value })));
                }}
                className="w-full border rounded-md px-3 py-2"
              >
                <option value="image">Use Images</option>
                <option value="icon">Use Icons + Gradients</option>
              </select>
            </div>
          </details>

          {/* Header */}
          <details open>
            <summary className="font-medium cursor-pointer text-lg">Section Header</summary>
            <div className="mt-3 space-y-4">
              <input value={title} onChange={e => setTitle(e.target.value)} className="w-full px-4 py-2 border rounded-md" placeholder="Main Title" />
              <input value={subtitle} onChange={e => setSubtitle(e.target.value)} className="w-full px-4 py-2 border rounded-md" placeholder="Subtitle" />

              <div>
                <label className="block text-sm font-medium mb-1">Header Alignment</label>
                <select
                  value={headerAlignment}
                  onChange={e => setHeaderAlignment(e.target.value)}
                  className="w-full border rounded-md px-3 py-2"
                >
                  <option value="text-left">Left</option>
                  <option value="text-center">Center</option>
                  <option value="text-right">Right</option>
                </select>
              </div>

              <div className="space-y-3">
                <h4 className="font-medium text-sm">Title Styling</h4>
                <input type="color" value={titleStyle.color} onChange={e => setTitleStyle({ ...titleStyle, color: e.target.value })} className="h-10 w-full rounded border" />
                <select value={titleStyle.fontSize} onChange={e => setTitleStyle({ ...titleStyle, fontSize: e.target.value })} className="w-full px-3 py-2 border rounded-md">
                  <option value="text-4xl md:text-5xl">4XL-5XL</option>
                  <option value="text-5xl md:text-6xl">5XL-6XL</option>
                  <option value="text-6xl md:text-7xl">6XL-7XL</option>
                </select>
                <select value={titleStyle.fontWeight} onChange={e => setTitleStyle({ ...titleStyle, fontWeight: e.target.value })} className="w-full px-3 py-2 border rounded-md">
                  <option value="font-bold">Bold</option>
                  <option value="font-semibold">Semibold</option>
                  <option value="font-medium">Medium</option>
                </select>
              </div>

              <div className="space-y-3">
                <h4 className="font-medium text-sm">Subtitle Styling</h4>
                <input type="color" value={subtitleStyle.color} onChange={e => setSubtitleStyle({ ...subtitleStyle, color: e.target.value })} className="h-10 w-full rounded border" />
                <select value={subtitleStyle.fontSize} onChange={e => setSubtitleStyle({ ...subtitleStyle, fontSize: e.target.value })} className="w-full px-3 py-2 border rounded-md">
                  <option value="text-lg">Large</option>
                  <option value="text-xl">XL</option>
                </select>
                <select value={subtitleStyle.fontWeight} onChange={e => setSubtitleStyle({ ...subtitleStyle, fontWeight: e.target.value })} className="w-full px-3 py-2 border rounded-md">
                  <option value="font-normal">Normal</option>
                  <option value="font-medium">Medium</option>
                </select>
              </div>
            </div>
          </details>

          {/* Categories */}
          <details open>
            <summary className="font-medium cursor-pointer text-lg">Categories ({categories.length})</summary>
            <div className="mt-3 space-y-4">
              <div className="flex justify-between items-center">
                <button onClick={addCategory} className="text-blue-600 text-sm font-medium hover:underline">+ Manual Add</button>
                <button onClick={openAddCategoryModal} className="text-blue-600 text-sm font-medium hover:underline">+ Add from List</button>
              </div>

              {categories.map((cat, idx) => (
                <details key={cat.id} open className="border rounded-xl p-5 bg-gray-50 shadow-sm">
                  <summary className="font-medium cursor-pointer flex justify-between items-center">
                    <span>{cat.name || `Category ${idx + 1}`}</span>
                    <div className="flex gap-2">
                      <button onClick={() => moveCategory(cat.id, -1)} disabled={idx === 0} className="p-1 hover:bg-gray-200 rounded disabled:opacity-50">↑</button>
                      <button onClick={() => moveCategory(cat.id, 1)} disabled={idx === categories.length - 1} className="p-1 hover:bg-gray-200 rounded disabled:opacity-50">↓</button>
                      <button onClick={() => removeCategory(cat.id)} className="p-1 text-red-600 hover:bg-red-50 rounded">×</button>
                    </div>
                  </summary>

                  <div className="mt-4 space-y-4">
                    <input value={cat.name} onChange={e => updateCategory(cat.id, 'name', e.target.value)} className="w-full px-3 py-2 border rounded-md" placeholder="Category Name" />
                    <input value={cat.items || ''} onChange={e => updateCategory(cat.id, 'items', e.target.value)} className="w-full px-3 py-2 border rounded-md" placeholder="Items count (e.g. 2.4k)" />

                    <div>
                      <label className="block text-sm font-medium mb-1">Display As</label>
                      <select
                        value={cat.displayMode || displayMode}
                        onChange={e => updateCategory(cat.id, 'displayMode', e.target.value)}
                        className="w-full border rounded-md px-3 py-2"
                      >
                        <option value="image">Image</option>
                        <option value="icon">Icon + Gradient</option>
                      </select>
                    </div>

                    {(cat.displayMode || displayMode) === 'icon' ? (
                      <>
                        <div>
                          <label className="block text-sm font-medium mb-1">Icon Name (Lucide)</label>
                          <input
                            value={cat.icon || 'ShoppingBag'}
                            onChange={e => updateCategory(cat.id, 'icon', e.target.value)}
                            className="w-full px-3 py-2 border rounded-md text-sm"
                            placeholder="Gamepad, Smartphone, Laptop..."
                          />
                        </div>
                        <div>
                          <label className="block text-sm font-medium mb-1">Gradient</label>
                          <input
                            value={cat.iconColor || 'from-blue-500 to-indigo-600'}
                            onChange={e => updateCategory(cat.id, 'iconColor', e.target.value)}
                            className="w-full px-3 py-2 border rounded-md text-sm"
                            placeholder="from-violet-500 to-purple-500"
                          />
                        </div>
                      </>
                    ) : (
                      <div>
                        <label className="block text-sm font-medium mb-1">Category Image</label>
                        <input
                          type="file"
                          accept="image/*"
                          onChange={e => handleImageUpload(cat.id, e)}
                          className="text-sm"
                        />
                        {cat.image && <img src={cat.image} alt="preview" className="mt-3 h-32 w-full object-cover rounded-lg" />}
                      </div>
                    )}

                    {/* Per-category title styling override */}
                    <details>
                      <summary className="text-sm font-medium cursor-pointer mt-2">Title Styling (override)</summary>
                      <div className="mt-3 space-y-3">
                        <input type="color" value={cat.titleStyle?.color || titleStyle.color} onChange={e => updateCategoryStyle(cat.id, 'titleStyle', 'color', e.target.value)} className="h-10 w-full rounded border" />
                        <select value={cat.titleStyle?.fontSize || titleStyle.fontSize} onChange={e => updateCategoryStyle(cat.id, 'titleStyle', 'fontSize', e.target.value)} className="w-full px-3 py-2 border rounded-md text-sm">
                          <option value="text-xl">XL</option>
                          <option value="text-2xl">2XL</option>
                          <option value="text-3xl">3XL</option>
                        </select>
                        <select value={cat.titleStyle?.fontWeight || titleStyle.fontWeight} onChange={e => updateCategoryStyle(cat.id, 'titleStyle', 'fontWeight', e.target.value)} className="w-full px-3 py-2 border rounded-md text-sm">
                          <option value="font-bold">Bold</option>
                          <option value="font-semibold">Semibold</option>
                        </select>
                      </div>
                    </details>

                    <details>
                      <summary className="text-sm font-medium cursor-pointer">Count / Subtitle Styling</summary>
                      <div className="mt-3 space-y-3">
                        <input type="color" value={cat.subtitleStyle?.color || subtitleStyle.color} onChange={e => updateCategoryStyle(cat.id, 'subtitleStyle', 'color', e.target.value)} className="h-10 w-full rounded border" />
                        <select value={cat.subtitleStyle?.fontSize || subtitleStyle.fontSize} onChange={e => updateCategoryStyle(cat.id, 'subtitleStyle', 'fontSize', e.target.value)} className="w-full px-3 py-2 border rounded-md text-sm">
                          <option value="text-base">Base</option>
                          <option value="text-lg">Large</option>
                        </select>
                      </div>
                    </details>
                  </div>
                </details>
              ))}
            </div>
          </details>

          {/* Grid & Card Settings – Conditional */}
          {preset !== 'carousel' && (
            <details open>
              <summary className="font-medium cursor-pointer text-lg">Grid & Card Settings</summary>
              <div className="mt-3 space-y-4">
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium mb-1">Mobile Columns</label>
                    <select value={grid.mobileCols} onChange={e => setGrid({ ...grid, mobileCols: Number(e.target.value) })} className="w-full border rounded-md px-3 py-2">
                      {[1,2,3,4].map(n => <option key={n} value={n}>{n}</option>)}
                    </select>
                  </div>
                  <div>
                    <label className="block text-sm font-medium mb-1">Desktop Columns</label>
                    <select value={grid.desktopCols} onChange={e => setGrid({ ...grid, desktopCols: Number(e.target.value) })} className="w-full border rounded-md px-3 py-2">
                      {[3,4,5,6,7,8].map(n => <option key={n} value={n}>{n}</option>)}
                    </select>
                  </div>
                </div>

                {['modern-glass', 'floating-circles', 'large-gradient', 'card-grid'].includes(preset) && (
                  <>
                    <div>
                      <label className="block text-sm font-medium mb-1">Card Height (px)</label>
                      <input type="number" value={cardHeight} onChange={e => setCardHeight(Number(e.target.value))} className="w-full border rounded-md px-3 py-2" min="280" max="500" />
                    </div>

                    <div>
                      <label className="block text-sm font-medium mb-1">Card Border Radius</label>
                      <select value={cardBorderRadius} onChange={e => setCardBorderRadius(e.target.value)} className="w-full border rounded-md px-3 py-2">
                        <option value="rounded-xl">Extra Large</option>
                        <option value="rounded-2xl">2XL</option>
                        <option value="rounded-3xl">3XL</option>
                        <option value="rounded-full">Full Circle</option>
                      </select>
                    </div>
                  </>
                )}

                {['modern-glass', 'floating-circles', 'large-gradient', 'card-grid'].includes(preset) && (
                  <div className="space-y-3">
                    <h4 className="font-medium text-sm">Global Card Styles</h4>
                    <input value={cardStyles.background} onChange={e => setCardStyles({ ...cardStyles, background: e.target.value })} className="w-full px-3 py-2 border rounded-md text-sm" placeholder="bg-white / bg-gradient-to-br ..." />
                    <input value={cardStyles.border} onChange={e => setCardStyles({ ...cardStyles, border: e.target.value })} className="w-full px-3 py-2 border rounded-md text-sm" placeholder="border border-white/30" />
                    <input value={cardStyles.shadow} onChange={e => setCardStyles({ ...cardStyles, shadow: e.target.value })} className="w-full px-3 py-2 border rounded-md text-sm" placeholder="shadow-2xl" />
                    <input value={cardStyles.hoverScale} onChange={e => setCardStyles({ ...cardStyles, hoverScale: e.target.value })} className="w-full px-3 py-2 border rounded-md text-sm" placeholder="hover:scale-105" />
                  </div>
                )}
              </div>
            </details>
          )}

          {/* Dev Mode – always available */}
          <details className="bg-yellow-50 border border-yellow-200 rounded-xl p-5">
            <summary className="font-semibold text-yellow-900 cursor-pointer">Dev Mode – Advanced Container</summary>
            <div className="mt-4 flex justify-between items-center mb-4">
              <h3 className="font-semibold text-yellow-900">Enabled</h3>
              <button 
                onClick={() => setDevMode(!devMode)} 
                className={`relative inline-flex h-6 w-11 rounded-full transition ${devMode ? 'bg-yellow-600' : 'bg-gray-300'}`}
              >
                <span className={`inline-block h-4 w-4 rounded-full bg-white transition ${devMode ? 'translate-x-6' : 'translate-x-1'}`} />
              </button>
            </div>

            {devMode && (
              <div className="space-y-4">
              <div>
                  <label className="block text-sm font-medium mb-1">Title & Subtitle Position</label>
                  <input value={container.textAlign} onChange={e => setContainer({ ...container, textAlign: e.target.value })} className="w-full px-3 py-2 border rounded-md text-sm" placeholder="py-12 md:py-16 px-4 md:px-8" placeholder='left ,right ,center' />
                </div>
                <div>
                  <label className="block text-sm font-medium mb-1">Padding</label>
                  <input value={container.padding} onChange={e => setContainer({ ...container, padding: e.target.value })} className="w-full px-3 py-2 border rounded-md text-sm" placeholder="py-12 md:py-16 px-4 md:px-8" />
                </div>
                <div>
                  <label className="block text-sm font-medium mb-1">Background</label>
                  <input value={container.background} onChange={e => setContainer({ ...container, background: e.target.value })} className="w-full px-3 py-2 border rounded-md text-sm" placeholder="bg-white or gradient or url(...)" />
                </div>
                <div>
                  <label className="block text-sm font-medium mb-1">Margin / Max Width</label>
                  <input value={container.margin} onChange={e => setContainer({ ...container, margin: e.target.value })} className="w-full px-3 py-2 border rounded-md text-sm" placeholder="mx-auto max-w-9xl" />
                </div>
                 <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Category Section Text Color</label>
                  <input
                  type="color"
                    value={container.textColor}
                    onChange={e => setContainer({ ...container, textColor: e.target.value })}
                    placeholder="#111827 or text-gray-900"
                    className="w-full px-3 py-2 border rounded-md text-sm"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Category Section Accent Color</label>
                  <input
                  type="color"
                    value={container.accentColor}
                    onChange={e => setContainer({ ...container, accentColor: e.target.value })}
                    placeholder="#111827 or text-gray-900"
                    className="w-full px-3 py-2 border rounded-md text-sm"
                  />
                </div>

                 <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Category Section Text Font Size</label>
                  <input
                
                    value={container.fontSize}
                    onChange={e => setContainer({ ...container, fontSize: e.target.value })}
                    placeholder="10px , 2em"
                    className="w-full px-3 py-2 border rounded-md text-sm"
                  />
                </div>

                 <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Category Section Font Family</label>
                  <input
                 
                    value={container.fontFamily}
                    onChange={e => setContainer({ ...container, fontFamily: e.target.value })}
                    placeholder="Tw Cen MT"
                    className="w-full px-3 py-2 border rounded-md text-sm"
                  />
                </div>
                  <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Button Gradient/Background</label>
                  <input
                    value={container.featuredBg}
                    onChange={e => setContainer({ ...container, featuredBg: e.target.value })}
                    placeholder="from-purple-600 to-pink-600"
                    className="w-full px-3 py-2 border rounded-md text-sm"
                  />
                </div>

                 <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Category Card Border Radius</label>
                  <input
                  type="number"
                  min="1"
                    value={container.borderRadius}
                    onChange={e => setContainer({ ...container, borderRadius: e.target.value })}
                    placeholder="10px"
                    className="w-full px-3 py-2 border rounded-md text-sm"
                  />
                </div>

                 <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Category Card Background</label>
                  <input
                    value={container.cardBackground}
                    onChange={e => setContainer({ ...container, cardBackground: e.target.value })}
                    placeholder="from-purple-600 to-pink-600"
                    className="w-full px-3 py-2 border rounded-md text-sm"
                  />
                </div>
              </div>
            )}
          </details>
        </div>

        {/* Fixed Save Button */}
        <div className="sticky bottom-0 w-96 bg-white border-t p-6 shadow-lg">
          <button
            onClick={saveCategorySettings}
            disabled={saving}
            className="w-full bg-blue-600 text-white py-4 rounded-xl font-bold hover:bg-blue-700 disabled:opacity-70 shadow transform hover:scale-105 transition"
          >
            {saving ? 'Saving...' : 'Save & Publish Categories'}
          </button>
        </div>
      </div>

      {/* Add from List Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl shadow-2xl max-w-4xl w-full max-h-[80vh] overflow-y-auto flex flex-col">
            <div className="sticky top-0 bg-white border-b px-6 py-4 flex justify-between items-center">
              <h2 className="text-xl font-bold">Add Categories from List</h2>
              <button onClick={() => setIsModalOpen(false)} className="text-gray-500 hover:text-gray-900 text-3xl">×</button>
            </div>

            <div className="p-6">
              <input
                value={searchQuery}
                onChange={e => setSearchQuery(e.target.value)}
                placeholder="Search categories..."
                className="w-full px-4 py-2 border rounded-md mb-6"
              />

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {allCategories
                  .filter(c => searchQuery === '' || c.name?.toLowerCase().includes(searchQuery.toLowerCase()))
                  .map(cat => (
                    <div
                      key={cat.id}
                      className={`p-4 border rounded-lg cursor-pointer transition ${
                        selectedCategoryIds.includes(cat.id) ? 'border-blue-500 bg-blue-50' : 'hover:bg-gray-50'
                      }`}
                      onClick={() => toggleCategorySelection(cat.id)}
                    >
                      <div className="flex items-center gap-3">
                        <input
                          type="checkbox"
                          checked={selectedCategoryIds.includes(cat.id)}
                          readOnly
                        />
                        <div className="flex-1">
                          <p className="font-medium">{cat.name}</p>
                          <p className="text-xs text-gray-500">ID: {cat.id}</p>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>

              {allCategories.filter(c => searchQuery === '' || c.name?.toLowerCase().includes(searchQuery.toLowerCase())).length === 0 && (
                <p className="text-center text-gray-500 mt-8">No categories found</p>
              )}
            </div>

            <div className="border-t px-6 py-4 flex justify-end gap-4 sticky bottom-0 bg-white">
              <button onClick={() => setIsModalOpen(false)} className="px-6 py-2 border rounded-lg hover:bg-gray-100">
                Cancel
              </button>
              <button
                onClick={confirmAddCategories}
                disabled={selectedCategoryIds.length === 0}
                className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed"
              >
                Add {selectedCategoryIds.length} Category{selectedCategoryIds.length !== 1 ? 's' : ''}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Full Screen Preview */}
      {fullScreenPreview && (
        <div className="fixed inset-0 bg-black/95 z-50 flex flex-col" onClick={() => setFullScreenPreview(false)}>
          <div className="bg-white/10 backdrop-blur px-6 py-4 flex justify-end">
            <button className="text-white text-4xl hover:text-gray-300">×</button>
          </div>
          <div className="flex-1 overflow-auto p-8" onClick={e => e.stopPropagation()}>
            <CategorySection config={currentConfig} />
          </div>
        </div>
      )}
    </div>
  );
};

export default CategoryAdmin;